import NavBar from "../Components/NavBar";


function HomeView() {

    return (
        <div>
            <NavBar/>
        </div>
    )
}

export default HomeView;